import { Box, Button } from "@mui/material";
import { CSSProperties, ReactNode } from "react";

interface Props {
  text?: string;
  children?: ReactNode;
  style?: CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
}

const StyledButton = ({ text, children, style, onClick, disabled }: Props) => {
  return (
    <Box className="StyledButton" sx={style}>
      <Button variant="contained" onClick={onClick} disabled={disabled}>
        {children || text}
      </Button>
    </Box>
  );
};

export default StyledButton;
